/// <reference path='../_all.ts' />

module part {
  'use strict';

  export class ServiceData {
    constructor(
      public PartsReference: PartsReference,
      public Pictures: any[],
      public Plans: TErsatzteillisteDocDataTable[],
      public ReferenceGroup: ReferenceGroup[],
      public Parts : Part, 
      public Products : Product 
    ) { }
  }

  export interface AvailabilityServiceData {
    [id: string] : Availability 
  }
  

  export class Availability {
    constructor(
      public Text: string,
      public Code: AvailabilityStatus
      ) { }
  }

  export enum AvailabilityStatus {
    OnlyByRequest = -1,
    Available = 1,
    Delayed = 0,
  }
  
  
  export class PartsReference{
    constructor(
      public Kategorien : ArtikelReferenzKategorie[],
      public Referenz2Object : ArtikelReferenz2Object[],
      public Gruppen : ArtikelReferenzGruppe[]
    ) { }
  }   


  
  export class ArtikelReferenzKategorie{
    constructor(
      public Nummer : number,
      public Bezeichnung : string,
      public DifferentiateGroups : boolean,
      public Grundausstattung : boolean,
      public Gruppen : ArtikelReferenzGruppe[]
    ) { }
  }   
  
  export class ArtikelReferenzGruppe{
    constructor(
      public Nummer : number,
      public Bezeichnung : string,
      public Grundausstattung : boolean,
      public Reihenfolge : number
    ) { }
  } 
  
  export class ArtikelReferenz2Object{
    constructor(
      public KategorieNummer : number,
      public GruppeNummer : number,
      public Grundausstattung : boolean,
      public ProduktNummer : number,
      public ItemNo : string,
      public ZusatzText : string
    ) { }
  } 

  export class ReferenceGroup{
    constructor(
      public ID : number,
      public IsBase : boolean,
      public NameD : string,
      public NameE : string,
      public Part2Product : ErsatzteillistePart2Product[],
      public Sorter : number
    ) { }
  }  
    
  export class Part2Product{
    constructor(
      public IsSerialNumberRequired : boolean,
      public IsServicePersonnelNeeded : boolean,
      public Part : Part,
      public Product : Product,
      public TextD : string,
      public TextE : string
    ) { }
  }  
  
    
  export class ErsatzteillistePart2Product {
    constructor(
      public Text : string,
      public IsServicePersonnelNeeded : boolean,
      public IsSerialNumberRequired : boolean,
      public Part : string,
      public Product : number
    ) { }
  }  

  
  export class Part {
    constructor(
      public IsSerialNumberRequired : boolean,
      public ExpireDate  : Date,  //deprecatd
      public HasAufAnfrage  : boolean,
      public HasComplexPrice  : boolean,
      public ID   : string,
      public IsClosed   : boolean,
      public IsNetto : boolean,
      public MutationDate : Date,
      public PriceCat : string,
      public StatusCode : number,
      public TextD : string,
      public TextE  : string,
      public TextF : string,
      public USPForOneUnit   : number,
      public WebStatusTextDeutsch : string,
      public WebStatusTextEnglisch  : string,
      public OnlyDetails  : boolean    
    ) { }
  }  

    
  export class Product {
    constructor(
      public CategoryId : number,
      public CategoryNameD : string,
      public CategoryNameE : string,
      public Id : number,
      public ImagePath : string,
      public IsCommingSoon : boolean,
      public IsNew : boolean,
      public IsObsolete : boolean,
      public IsTemporary : boolean,
      public KillingDate : Date,
      public LaunchDate : Date,
      public LongDescD : string,
      public LongDescE : string,
      public Name : string,
      public ProductImageName : string,
      public TextD : string,
      public TextE : string,
      public UrlD : string,
      public UrlE : string
    ) { }
  }  






}